import type * as Actions from "./actions";
import { ActionTypes } from "./actionTypes";

import type { DeviceStatusSubscription } from "@cobliteam/common-types";

import type { UserAlertSettings } from "@cobliteam/api-lib";

export const loadAlertSettingRequest = (): Actions.LoadAlertSettingRequest => ({
  type: ActionTypes.LOAD_ALERT_SETTING_REQUEST,
});

export const loadAlertSettingSucceeded = (
  settings: UserAlertSettings[],
): Actions.LoadAlertSettingSucceeded => ({
  type: ActionTypes.LOAD_ALERT_SETTING_SUCCEEDED,
  payload: settings,
});

export const loadAlertSettingFailed = (): Actions.LoadAlertSettingFailed => ({
  type: ActionTypes.LOAD_ALERT_SETTING_FAILED,
});

export const updateAlertSettingRequest = (
  settings: UserAlertSettings,
): Actions.UpdateAlertSettingRequest => ({
  type: ActionTypes.UPDATE_ALERT_SETTING_REQUEST,
  payload: settings,
});

export const updateAlertSettingEnd = (): Actions.UpdateAlertSettingEnd => ({
  type: ActionTypes.UPDATE_ALERT_SETTING_END,
});

export const loadDeviceStatusSubscriptionRequest =
  (): Actions.LoadDeviceStatusSubscriptionRequest => ({
    type: ActionTypes.LOAD_DEVICE_STATUS_SUBSCRIPTION_REQUEST,
  });

export const loadDeviceStatusSubscriptionSucceeded = (
  subscription: DeviceStatusSubscription,
): Actions.LoadDeviceStatusSubscriptionSucceeded => ({
  type: ActionTypes.LOAD_DEVICE_STATUS_SUBSCRIPTION_SUCCEEDED,
  payload: subscription,
});

export const loadDeviceStatusSubscriptionFailed =
  (): Actions.LoadDeviceStatusSubscriptionFailed => ({
    type: ActionTypes.LOAD_DEVICE_STATUS_SUBSCRIPTION_FAILED,
  });

export const updateDeviceStatusSubscriptionRequest = (
  subscription: DeviceStatusSubscription,
): Actions.UpdateDeviceStatusSubscriptionRequest => ({
  type: ActionTypes.UPDATE_DEVICE_STATUS_SUBSCRIPTION_REQUEST,
  payload: subscription,
});

export const updateDeviceStatusSubscriptionEnd =
  (): Actions.UpdateDeviceStatusSubscriptionEnd => ({
    type: ActionTypes.UPDATE_DEVICE_STATUS_SUBSCRIPTION_END,
  });
